import axios from 'axios'

/**
 *
 * @returns List of Challenge Types
 */
export const getAllChallengeTypes = async () => {
  const response = await axios.get('challenge/types')
  return response
}

/**
 *
 * @param {object} payload Cretae Challenge Object
 * @returns if success then challenge id
 */
export const createChallenge = async (payload) => {
  const response = await axios.post('challenge', payload)
  return response
}

/**
 * @param {string} challengeId
 * @param {object} payload Cretae Challenge Object
 * @returns if success then challenge id
 */
export const updateChallenge = async (challengeId, payload) => {
  const response = await axios.put(`challenge/${challengeId}`, payload)
  return response
}

/**
 *
 * @param {string|number} workspaceId
 * @param {Object} filter
 * @returns List of all challenges for a particular workspaceId
 */
export const getAllChallenges = async (workspaceId, filter) => {
  const response = await axios.post(
    `challenge/list${workspaceId ? `?workspaceId=${workspaceId}` : ''}`,
    filter
  )
  return response
}

/**
 *
 * @param {string} challengeId
 * @returns return a particular challenge
 */
export const getChallengeById = async (challengeId) => {
  const response = await axios.get(`challenge/${challengeId}`, {
    checkWorkspaceId: true
  })
  return response
}

/**
 *
 * @param {string} challengeId
 * @returns
 */
export const deleteChallenegeById = async (challengeId) => {
  const response = await axios.delete(`challenge/${challengeId}`)
  return response
}

/**
 *
 * @param {string} contestId
 * @param {object} languages
 * @returns
 */
export const getChallengeSuggestion = async (
  challengeTypeId,
  languages = [],
  contestId,
  workspaceId,
  mode = null,
  tags = [],
  difficulty = '',
  searchQuery = '',
  axiosSource
) => {
  const query = {
    ...(challengeTypeId ? { challengeTypeId } : {}),
    ...(workspaceId ? { workspaceId } : {}),
    ...(contestId ? { contestId } : {}),
    ...(mode ? { mode } : {}),
    ...(difficulty ? { difficulty } : {}),
    ...(tags ? { tags } : {}),
    ...(languages ? { languages } : {}),
    ...(searchQuery ? { searchQuery } : {})
  }

  const response = await axios.post(`challenge/suggestions/v1`, query, {
    ...(axiosSource ? { cancelToken: axiosSource?.token } : {})
  })
  return response
}
/**
 *
 * @param {string} workspaceId also contestId while updating
 * @returns {array} of challenges
 */
export const getDemoChallengeSuggestion = async (workspaceId, contestId) => {
  const response = await axios.post(
    `challenge/demo/suggestions?workspaceId=${workspaceId}${contestId ? `&contestId=${contestId}` : ''
    }`
  )
  return response
}

/**
 *
 * @param {string} challengeId
 * @param {string} workspaceId
 * @returns
 */
export const getAllTestcaseForChallenge = async (challengeId, workspaceId) => {
  const response = await axios.get(
    `testcases?challengeId=${challengeId}&workspaceId=${workspaceId}`
  )
  return response
}

/**
 * @param {object} payload
 * @param {string} challengeId
 * @param {string} workspaceId
 * @returns
 */
export const createTestcaseForChallenge = async (
  payload,
  challengeId,
  workspaceId
) => {
  const response = await axios.post(
    `testcases?challengeId=${challengeId}&workspaceId=${workspaceId}`,
    payload
  )
  return response
}

/**
 * @param {object} payload
 * @param {string} challengeId
 * @param {string} workspaceId
 * @returns
 */
export const updateTestcaseForChallenge = async (
  payload,
  challengeId,
  workspaceId
) => {
  const response = await axios.put(
    `testcases?challengeId=${challengeId}&workspaceId=${workspaceId}`,
    payload
  )
  return response
}

/**
 * @param {string} testcaseId
 * @param {string} challengeId
 * @param {string} workspaceId
 * @returns
 */
export const deleteTestcaseForChallenge = async (
  testcaseId,
  challengeId,
  workspaceId
) => {
  const response = await axios.delete(
    `testcases/${testcaseId}?challengeId=${challengeId}&workspaceId=${workspaceId}`
  )
  return response
}

/**
 * @param {string} testcaseType
 * @param {string} challengeId
 * @param {string} workspaceId
 * @returns
 */
export const updateTestCaseTypeForChallenge = async (
  testcaseType,
  challengeId,
  workspaceId
) => {
  const response = await axios.put(
    `testcases/change-type/${testcaseType}?challengeId=${challengeId}&workspaceId=${workspaceId}`
  )
  return response
}

/**
 *
 * @returns
 */
export const getChallengeLibrary = async () => {
  const response = await axios.get(`cache/challenge-library-list`)
  return response
}

/**
 *
 * @param {object} payload
 * @returns updates isLive key for challenge
 */
export const updateChallengeStatus = async (payload) => {
  const response = await axios.put(`challenge/update-status`, payload)
  return response
}

/**
 *
 * @param {object} payload
 * @returns update's challenge subscription plans
 */
export const updateChallengeSubscription = async (payload) => {
  const response = await axios.put(`challenge/update-subscriptions`, payload)
  return response
}

/**
 *
 * @param {object} payload
 * @returns update's challenge tag options
 */
export const updateChallengeTags = async (payload) => {
  const response = await axios.put(`challenge/update-tags`, payload)
  return response
}

/**
 *
 * @param {object} paylaod
 * @returns update's challenge difficulty
 */
export const updateChallengeDifficulty = async (payload) => {
  const response = await axios.put(`challenge/update-difficulty`, payload)
  return response
}

/**
 *
 * @returns array of tags
 */
export const getChallengeTags = async (
  challengeTypeId = null,
  workspaceId = null,
  query = ''
) => {
  const queryObj = {
    ...(challengeTypeId ? { challengeTypeId } : {}),
    ...(workspaceId ? { workspaceId } : {}),
    ...(query ? { query } : {})
  }

  const queryString = new URLSearchParams(queryObj).toString()

  const response = await axios.get(
    `challenge/tags${queryString ? `?${queryString}` : ''}`
  )
  return response
}

// ===========================================================
// PUBLISH TO GLOBAL LIBRARY API CALLS
// ===========================================================

/**
 *
 * @returns boolean
 */
export const getPublishPermission = async (workspaceId) => {
  const response = await axios.get(
    `tenants/show-publish${workspaceId ? `?workspaceId=${workspaceId}` : ''}`
  )
  return response
}

/**
 *
 * @param {string} challengeId
 * @returns
 */
export const publishChallenges = async (challengeId) => {
  const response = await axios.post(`challenge/move-to-global`, null, {
    params: { challengeId }
  })

  return response
}

/**
 *
 * @param {string} questionId
 * @returns
 */
export const publishQuestion = async (questionId) => {
  const response = await axios.post(
    `mcq/move-to-global${questionId ? `?questionId=${questionId}` : ''}`
  )
  return response
}

export const addAIQuestionToLibrary = async (questionId, isLive = false) => {
  const response = await axios.post(`mcq-challenge/move-to-library`, { questionId, isLive })
  return response
}

export const publishQuestionBulk = async (payload) => {
  const response = await axios.post(`mcq/move-multiple-to-global`, payload)
  return response
}

// ===========================================================
/**
 *
 * @param {object} payload {questionSet:{},workspaceId,isPrimarySet}
 * @returns
 */
export const questionSetValidation = async (payload) => {
  const response = await axios.post(`mcq/validate-question-set`, payload)
  return response
}

/**
 *
 * @param {object} payload  {challengeId,topicId,tags,includeLibrary}
 * @returns
 */
export const getSwapQuestionSuggestions = async (payload) => {
  const response = await axios.post(`mcq/swap-question-suggestions`, payload)
  return response
}

/**
 *
 * @param {object} payload  {challengeId,oldQuestionId,replacementQuestionId}
 * @returns
 */
export const swapWithSelectedQuestion = async (payload) => {
  const response = await axios.put(`challenge/update-questions`, payload)
  return response
}

/**
 *
 * @param {object} payload {challengeId,programmingChallengeId,workspaceId,solutionLabel}
 * @returns
 */
export const addAISolution = async (payload) => {
  const response = await axios.post(`challenge/solution`, payload)
  return response
}

/**
 *
 * @param {object} payload {challengeId,programmingChallengeId,workspaceId,solutionLabel}
 * @returns
 */
export const updateAISolution = async (payload) => {
  const response = await axios.put(`challenge/solution`, payload)
  return response
}

/**
 *
 * @param {string} solutionId
 * @returns
 */
export const getAISolution = async (solutionId, challengeId) => {
  const response = await axios.get('challenge/solution', {
    params: { solutionId, challengeId }
  })
  return response
}

/**
 *
 * @param {string} programmingChallengeId
 * @returns
 */
export const getAllAISolutions = async (programmingChallengeId) => {
  const response = await axios.get(`challenge/solutions/list`, {
    params: { programmingChallengeId }
  })
  return response
}

/**
 *
 * @param {object} payload {programmingChallengeId,workspaceId,codeFiles}
 * @returns
 */
export const getAIGeneratedSolution = async (payload) => {
  const response = await axios.post(`challenge/generate-solution`, payload)
  return response
}
